// Taken directly from http://jsfiddle.net/bcaudan/vTZZ5/
export function ngRightClickDirective($parse) {
    'ngInject';
    return function (scope, element, attrs) {
        let fn = $parse(attrs.ngRightClick);
        element.bind('contextmenu', function (event) {
            scope.$apply(function () {
                event.preventDefault();
                fn(scope, { $event: event });
            });
        });
    };
}
